import React, { useEffect } from "react";
import { Link } from "react-router-dom";

const DataAnalytics = () => {
  useEffect(() => {
    // Scroll to the banner section on page load
    window.scrollTo(0, 0);
  }, []);

  const scrollToSection = (id) => {
    const targetElement = document.getElementById(id);
    window.scrollTo({
      top: targetElement.offsetTop - 60, // Adjust this value to add space above the section
      behavior: "smooth",
    });
  };

  return (
    <div>
      <section className="banner">
        <div className="banner-overlay"></div>
        <div className="banner-content">
          <h6 className="banner-subtitle">Services / Data Analytics</h6>
          <hr />
          <h1 className="banner-title">
            Enhance your business success <br /> through data-driven insights
            and analytics.
          </h1>
          <button className="banner-button mt-3">
            <Link to="/contact" className="text-decoration-none text-white">
              Let’s talk <span className="arrow">→</span>
            </Link>
          </button>
        </div>
        <img
          src="./assets/img/3001.png"
          alt="Banner Background"
          className="banner-image"
        />
      </section>

      <section id="about_pg" className="p_3">
        <div className="container-xl">
          <div className="row about_pg1">
            <div className="col-md-6">
              <div className="about_pg1l mt-5">
                <h6 className="col_yell">Data Analytics</h6>
                <h2 className="mt-3 mb-3">
                  Drive faster results through analytics
                </h2>
                <p>
                  Data is central to business transformation. Our solutions
                  deliver insights that enable you to create innovative products
                  and services, improve customer experiences, and drive better
                  business results.
                </p>
              </div>
            </div>
            <div className="col-md-6">
              <div className="about_pg1r">
                <div className="grid clearfix">
                  <figure className="effect-jazz mb-0">
                    <a href="#">
                      <img
                        src="./assets/img/3001.png"
                        className="w-100"
                        alt="abc"
                      />
                    </a>
                  </figure>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="our-approach">
        <h2 className="approach-title">Our Approach</h2>
        <div className="approach-container">
          <div className="approach-step">
            <i className="fa fa-clipboard-check fa-3x" aria-hidden="true"></i>
            <h3>Understand Your Needs</h3>
            <p>
              We identify your business goals to align with data strategies.
            </p>
          </div>

          <div className="approach-step">
            <i className="fa fa-database fa-3x" aria-hidden="true"></i>
            <h3>Data Integration</h3>
            <p>We bring data from multiple sources into a unified platform.</p>
          </div>

          <div className="approach-step">
            <i className="fa fa-wrench fa-3x" aria-hidden="true"></i>
            <h3>Data Preparation</h3>
            <p>
              We ensure clean and analysis-ready data for accurate insights.
            </p>
          </div>

          <div className="approach-step">
            <i className="fa fa-chart-line fa-3x" aria-hidden="true"></i>
            <h3>Data Visualization</h3>
            <p>
              We create user-friendly dashboards to present valuable insights.
            </p>
          </div>

          <div className="approach-step">
            <i className="fa fa-lightbulb fa-3x" aria-hidden="true"></i>
            <h3>Insightful Strategies</h3>
            <p>We provide actionable recommendations to achieve your goals.</p>
          </div>

          <div className="approach-step">
            <i className="fa fa-eye fa-3x" aria-hidden="true"></i>
            <h3>Continuous Monitoring</h3>
            <p>
              We track progress and adjust strategies for sustainable success.
            </p>
          </div>
        </div>
      </section>

      <section id="about_pg" className="p_3">
        <div className="container-xl">
          <div className="row serv_h1 mb-4 mt-4">
            <div className="col-md-9">
              <div className="serv_h1l">
                <h3>Our solutions</h3>
                <p className="mb-0">Our Customized Solutions</p>
              </div>
            </div>
          </div>
          <div className="menu mt-5">
            <div className="menu-item">
              <button
                onClick={() => scrollToSection("overview")}
                className="scroll-link"
              >
                Transaction Analytics
              </button>
              <span className="icon">⌄</span>
            </div>
            <div className="menu-item">
              <button
                onClick={() => scrollToSection("sales-analytics")}
                className="scroll-link"
              >
                Sales Analytics
              </button>
              <span className="icon">⌄</span>
            </div>
            <div className="menu-item">
              <button
                onClick={() => scrollToSection("election-analytics")}
                className="scroll-link"
              >
                Election Analytics
              </button>
              <span className="icon">⌄</span>
            </div>
            <div className="menu-item">
              <button
                onClick={() => scrollToSection("pharmaceutical-analytics")}
                className="scroll-link"
              >
                Pharmaceutical
              </button>
              <span className="icon">⌄</span>
            </div>

            <div className="menu-item">
              <button
                onClick={() => scrollToSection("customer-analytics")}
                className="scroll-link"
              >
                Customer Analytics
              </button>
              <span className="icon">⌄</span>
            </div>
            <div className="menu-item">
              <button
                onClick={() => scrollToSection("workforce-analytics")}
                className="scroll-link"
              >
                Workforce Analytics
              </button>
              <span className="icon">⌄</span>
            </div>
          </div>

          <div className="pt-5">
            <div id="overview" className="p_3">
              <h6 style={{ color: "#007bff" }}>Transaction Analytics</h6>
              <h4>Transaction Analytics for Smarter Decisions</h4>
              <hr />

              <div className="row">
                <div className="col-md-6">
                  <h5 className="pt-4 pb-3 col_yell">
                    What Transaction Analytics Does
                  </h5>
                  <ul>
                    <li>
                      <strong>Tracking Patterns:</strong>
                      <ul>
                        <li>
                          Identifies trends, seasonal spikes, and customer
                          preferences.
                        </li>
                      </ul>
                    </li>
                    <li>
                      <strong>Fraud Detection:</strong>
                      <ul>
                        <li>
                          Detects unusual transactions and real-time anomalies
                          with AI/ML.
                        </li>
                      </ul>
                    </li>
                    <li>
                      <strong>Customer Segmentation:</strong>
                      <ul>
                        <li>
                          Groups customers by behavior for targeted marketing.
                        </li>
                      </ul>
                    </li>
                    <li>
                      <strong>Operational Optimization:</strong>
                      <ul>
                        <li>
                          Identifies inefficiencies and suggests workflow
                          improvements.
                        </li>
                      </ul>
                    </li>
                    <li>
                      <strong>Revenue Insights:</strong>
                      <ul>
                        <li>
                          Analyzes sales and revenue for data-driven pricing and
                          product strategies.
                        </li>
                      </ul>
                    </li>
                  </ul>
                </div>

                <div className="col-md-6">
                  <h5 className="pt-4 pb-3 col_yell">Benefits</h5>
                  <ul>
                    <li>
                      <strong>Enhanced Decision-Making:</strong>
                      <ul>
                        <li>
                          Offers real-time insights into trends and customer
                          behavior.
                        </li>
                      </ul>
                    </li>
                    <li>
                      <strong>Fraud Prevention:</strong>
                      <ul>
                        <li>
                          Minimizes financial losses and ensures secure
                          transactions.
                        </li>
                      </ul>
                    </li>
                    <li>
                      <strong>Improved Customer Experience:</strong>
                      <ul>
                        <li>
                          {" "}
                          Provides personalized services and reduces errors.
                        </li>
                      </ul>
                    </li>
                    <li>
                      <strong>Increased Revenue:</strong>
                      <ul>
                        <li>
                          Boosts sales by targeting profitable segments and
                          trends. and more
                        </li>
                      </ul>
                    </li>

                    <li>
                      <strong>Operational Efficiency:</strong>
                      <ul>
                        <li>
                          Reduces errors, saves time, and optimizes resources.
                        </li>
                      </ul>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div id="sales-analytics" className="p_3">
              <h6 style={{ color: "#007bff" }}>Sales Analytics</h6>
              <h3>Sales Analytics for Business Growth</h3>
              <hr />
              <div className="content row">
                <div className="col-md-6">
                  <h5 className="pt-4 pb-3 col_yell">
                    What Sales Analytics Does
                  </h5>
                  <ul>
                    <li>
                      <strong>Performance Tracking:</strong>
                      <ul>
                        <li>
                          Monitors sales across products, regions, and time
                          periods.
                        </li>
                      </ul>
                    </li>

                    <li>
                      <strong>Forecasting:</strong>
                      <ul>
                        <li>
                          Predicts future sales using historical data and
                          trends.
                        </li>
                      </ul>
                    </li>
                    <li>
                      <strong>Customer Behavior Analysis:</strong>
                      <ul>
                        <li>Understands buying patterns and preferences.</li>
                      </ul>
                    </li>
                    <li>
                      <strong>Revenue Breakdown:</strong>
                      <ul>
                        <li>
                          Identifies contributions from products, services, and
                          segments.
                        </li>
                      </ul>
                    </li>
                    <li>
                      <strong>Market Trends:</strong>
                      <ul>
                        <li>Aligns sales strategies with industry trends.</li>
                      </ul>
                    </li>
                  </ul>
                </div>

                <div className="col-md-6">
                  <h5 className="pt-4 pb-3 col_yell">Benefits</h5>
                  <ul>
                    <li>
                      <strong>Improved Sales Strategies:</strong>

                      <ul>
                        <li>Enables targeted campaigns and pricing models.</li>
                      </ul>
                    </li>
                    <li>
                      <strong>Forecasting Accuracy:</strong>

                      <ul>
                        <li>
                          Provides reliable demand planning and inventory
                          management.
                        </li>
                      </ul>
                    </li>
                    <li>
                      <strong>Boosted Revenue:</strong>

                      <ul>
                        <li>
                          {" "}
                          Highlights top-performing products and upselling
                          opportunities.
                        </li>
                      </ul>
                    </li>
                    <li>
                      <strong>Optimized Resource Allocation:</strong>

                      <ul>
                        <li>Focuses on high-value sales opportunities.</li>
                      </ul>
                    </li>
                    <li>
                      <strong>Better Customer Relationships:</strong>

                      <ul>
                        <li>Offers personalized sales approaches.</li>
                      </ul>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div id="election-analytics" className="p_3">
              <h6 style={{ color: "#007bff" }}>Election Analytics</h6>
              <h3>
                Optimizing Election Campaigns through Data-Driven Insights
              </h3>

              <hr />
              <div className="content row">
                <div className="col-md-6">
                  <h5 className="pt-4 pb-3 col_yell">
                    What Election Analytics Does
                  </h5>
                  <ul>
                    <li>
                      <strong>Voter Behavior Analysis:</strong>
                      <ul>
                        <li>
                          Tracks and analyzes voting trends, demographics, and
                          preferences.
                        </li>
                      </ul>
                    </li>
                    <li>
                      <strong>Polling Accuracy:</strong>
                      <ul>
                        <li>
                          Evaluates the accuracy of polls in predicting voting
                          outcomes.
                        </li>
                      </ul>
                    </li>
                    <li>
                      <strong>Swing State Analysis:</strong>
                      <ul>
                        <li>
                          Identifies key battleground states and tracks
                          sentiment in those regions.
                        </li>
                      </ul>
                    </li>
                    <li>
                      <strong>Election Trends:</strong>
                      <ul>
                        <li>
                          Analyzes historical data to forecast potential
                          outcomes.
                        </li>
                      </ul>
                    </li>
                    <li>
                      <strong>Campaign Impact Assessment:</strong>
                      <ul>
                        <li>
                          Assesses the effectiveness of campaign strategies and
                          media coverage.
                        </li>
                      </ul>
                    </li>
                  </ul>
                </div>

                <div className="col-md-6">
                  <h5 className="pt-4 pb-3 col_yell">Benefits</h5>
                  <ul>
                    <li>
                      <strong>Informed Campaign Strategy:</strong>
                      <ul>
                        <li>
                          Provides insights for tailoring messages and
                          strategies to voter preferences.
                        </li>
                      </ul>
                    </li>
                    <li>
                      <strong>Improved Polling Accuracy:</strong>
                      <ul>
                        <li>
                          Enhances predictive models for more accurate
                          forecasts.
                        </li>
                      </ul>
                    </li>
                    <li>
                      <strong>Targeted Voter Outreach:</strong>
                      <ul>
                        <li>
                          Helps campaigns focus their efforts on key voter
                          segments.
                        </li>
                      </ul>
                    </li>
                    <li>
                      <strong>Election Integrity Monitoring:</strong>
                      <ul>
                        <li>
                          Identifies any irregularities that may indicate fraud
                          or suppression.
                        </li>
                      </ul>
                    </li>
                    <li>
                      <strong>Policy Formation:</strong>
                      <ul>
                        <li>
                          Provides insights into voter concerns, guiding future
                          policy decisions.
                        </li>
                      </ul>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div id="pharmaceutical-analytics" className="p_3">
              <h6 style={{ color: "#007bff" }}>Pharmaceutical Analytics</h6>
              <h3>
                Optimizing Pharmaceutical Operations with Data-Driven Insights
              </h3>

              <hr />
              <div className="content row">
                <div className="col-md-6">
                  <h5 className="pt-4 pb-3 col_yell">
                    What Pharmaceutical Analytics Does
                  </h5>
                  <ul>
                    <li>
                      <strong>Drug Efficacy Analysis:</strong>
                      <ul>
                        <li>
                          Analyzes clinical trial data to assess the
                          effectiveness of pharmaceutical products.
                        </li>
                      </ul>
                    </li>
                    <li>
                      <strong>Market Demand Forecasting:</strong>
                      <ul>
                        <li>
                          Predicts demand for pharmaceutical products based on
                          market trends and historical data.
                        </li>
                      </ul>
                    </li>
                    <li>
                      <strong>Supply Chain Optimization:</strong>
                      <ul>
                        <li>
                          Identifies inefficiencies in the supply chain and
                          suggests improvements for cost reduction.
                        </li>
                      </ul>
                    </li>
                    <li>
                      <strong>Patient Outcomes Tracking:</strong>
                      <ul>
                        <li>
                          Tracks patient outcomes to assess long-term effects of
                          treatments and medications.
                        </li>
                      </ul>
                    </li>
                    <li>
                      <strong>Regulatory Compliance Monitoring:</strong>
                      <ul>
                        <li>
                          Monitors adherence to industry regulations to ensure
                          compliance and avoid penalties.
                        </li>
                      </ul>
                    </li>
                  </ul>
                </div>

                <div className="col-md-6">
                  <h5 className="pt-4 pb-3 col_yell">Benefits</h5>
                  <ul>
                    <li>
                      <strong>Improved Drug Development:</strong>
                      <ul>
                        <li>
                          Provides data-driven insights into the most promising
                          drug candidates and clinical trials.
                        </li>
                      </ul>
                    </li>
                    <li>
                      <strong>Enhanced Patient Safety:</strong>
                      <ul>
                        <li>
                          Helps monitor patient reactions and adverse effects,
                          improving overall safety standards.
                        </li>
                      </ul>
                    </li>
                    <li>
                      <strong>Cost Efficiency:</strong>
                      <ul>
                        <li>
                          Optimizes production and distribution to minimize
                          operational costs.
                        </li>
                      </ul>
                    </li>
                    <li>
                      <strong>Faster Time-to-Market:</strong>
                      <ul>
                        <li>
                          Accelerates drug development and approval processes
                          through predictive modeling and simulations.
                        </li>
                      </ul>
                    </li>
                    <li>
                      <strong>Increased Market Reach:</strong>
                      <ul>
                        <li>
                          Improves targeting of pharmaceutical products to
                          specific regions and demographics.
                        </li>
                      </ul>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div id="customer-analytics" className="p_3">
              <h6 style={{ color: "#007bff" }}>Customer Analytics</h6>
              <h3>Driving Business Growth through Customer Insights</h3>

              <hr />
              <div className="content row">
                <div className="col-md-6">
                  <h5 className="pt-4 pb-3 col_yell">
                    What Customer Analytics Does
                  </h5>
                  <ul>
                    <li>
                      <strong>Customer Segmentation:</strong>
                      <ul>
                        <li>
                          Groups customers based on demographics, behavior, and
                          purchasing patterns.
                        </li>
                      </ul>
                    </li>
                    <li>
                      <strong>Purchase Behavior Analysis:</strong>
                      <ul>
                        <li>
                          Analyzes customer buying habits, including frequency,
                          preferences, and spending patterns.
                        </li>
                      </ul>
                    </li>
                    <li>
                      <strong>Customer Lifetime Value (CLV) Prediction:</strong>
                      <ul>
                        <li>
                          Predicts the long-term value of customers based on
                          historical purchase data.
                        </li>
                      </ul>
                    </li>
                    <li>
                      <strong>Churn Prediction:</strong>
                      <ul>
                        <li>
                          Identifies customers at risk of leaving and suggests
                          retention strategies.
                        </li>
                      </ul>
                    </li>
                    <li>
                      <strong>Customer Satisfaction Monitoring:</strong>
                      <ul>
                        <li>
                          Monitors customer feedback and satisfaction levels to
                          improve products and services.
                        </li>
                      </ul>
                    </li>
                  </ul>
                </div>

                <div className="col-md-6">
                  <h5 className="pt-4 pb-3 col_yell">Benefits</h5>
                  <ul>
                    <li>
                      <strong>Personalized Marketing:</strong>
                      <ul>
                        <li>
                          Enables targeted marketing campaigns based on customer
                          preferences and behaviors.
                        </li>
                      </ul>
                    </li>
                    <li>
                      <strong>Increased Customer Retention:</strong>
                      <ul>
                        <li>
                          Helps identify high-risk customers and implement
                          strategies to reduce churn.
                        </li>
                      </ul>
                    </li>
                    <li>
                      <strong>Improved Product Offerings:</strong>
                      <ul>
                        <li>
                          Provides insights into customer needs, enabling the
                          development of better products and services.
                        </li>
                      </ul>
                    </li>
                    <li>
                      <strong>Better Decision Making:</strong>
                      <ul>
                        <li>
                          Helps businesses make informed decisions about
                          pricing, promotions, and product launches.
                        </li>
                      </ul>
                    </li>
                    <li>
                      <strong>Increased Revenue:</strong>
                      <ul>
                        <li>
                          Improves sales strategies, boosting revenue through
                          better targeting and segmentation.
                        </li>
                      </ul>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div id="workforce-analytics" className="p_3">
              <h6 style={{ color: "#007bff" }}>Workforce Analytics</h6>
              <h3>
                Optimizing Workforce Performance through Data-Driven Insights
              </h3>

              <hr />
              <div className="content row">
                <div className="col-md-6">
                  <h5 className="pt-4 pb-3 col_yell">
                    What Workforce Analytics Does
                  </h5>
                  <ul>
                    <li>
                      <strong>Employee Performance Analysis:</strong>
                      <ul>
                        <li>
                          Measures employee performance and productivity levels
                          to identify high performers and areas for improvement.
                        </li>
                      </ul>
                    </li>
                    <li>
                      <strong>Workforce Utilization:</strong>
                      <ul>
                        <li>
                          Analyzes how effectively the workforce is utilized,
                          identifying underused skills or resources.
                        </li>
                      </ul>
                    </li>
                    <li>
                      <strong>Talent Management:</strong>
                      <ul>
                        <li>
                          Assesses the skill sets of employees and identifies
                          gaps in talent to guide recruitment and development
                          strategies.
                        </li>
                      </ul>
                    </li>
                    <li>
                      <strong>Employee Engagement and Satisfaction:</strong>
                      <ul>
                        <li>
                          Tracks employee engagement and satisfaction through
                          surveys and feedback to improve workplace culture.
                        </li>
                      </ul>
                    </li>
                    <li>
                      <strong>Turnover and Retention Analysis:</strong>
                      <ul>
                        <li>
                          Analyzes employee turnover patterns and identifies
                          factors contributing to employee attrition or
                          retention.
                        </li>
                      </ul>
                    </li>
                  </ul>
                </div>

                <div className="col-md-6">
                  <h5 className="pt-4 pb-3 col_yell">Benefits</h5>
                  <ul>
                    <li>
                      <strong>Improved Talent Acquisition:</strong>
                      <ul>
                        <li>
                          Helps companies identify the right skill sets needed
                          for recruitment, improving the hiring process.
                        </li>
                      </ul>
                    </li>
                    <li>
                      <strong>Enhanced Employee Productivity:</strong>
                      <ul>
                        <li>
                          Identifies factors affecting productivity and enables
                          management to take actions to improve output.
                        </li>
                      </ul>
                    </li>
                    <li>
                      <strong>Data-Driven Workforce Planning:</strong>
                      <ul>
                        <li>
                          Helps HR teams optimize workforce size, staffing
                          levels, and talent development strategies based on
                          data.
                        </li>
                      </ul>
                    </li>
                    <li>
                      <strong>Employee Retention and Engagement:</strong>
                      <ul>
                        <li>
                          Improves employee retention by addressing factors
                          contributing to dissatisfaction and promoting
                          engagement.
                        </li>
                      </ul>
                    </li>
                    <li>
                      <strong>Cost Optimization:</strong>
                      <ul>
                        <li>
                          Helps companies reduce costs by optimizing labor
                          costs, improving workforce scheduling, and reducing
                          turnover-related expenses.
                        </li>
                      </ul>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="serv_h" className="p_3">
        <div className="container-xl">
          <div
            className="row serv_h3 mt-4  pt-5 pb-5 mx-0 px-4"
            style={{ backgroundColor: "black", color: "white" }}
          >
            <div className="col-md-8">
              <div className="serv_h3l">
                <h6 className="">Benefits</h6>
                <h2 className="text-white">
                  Drive your business goals with agility through actionable
                  insights.
                </h2>
                <p className="text-white mt-3">
                  "Integrate analytics to improve customer experiences and
                  reduce costs, innovate data-driven solutions, leverage AI for
                  resilience and adaptability, and build sustainable businesses
                  with key performance metrics."
                </p>
                <button className="banner-button mt-3">
                  <Link
                    to="/contact"
                    className="text-decoration-none text-white"
                  >
                    Let’s talk <span className="arrow">→</span>
                  </Link>
                </button>
              </div>
            </div>
            <div className="col-md-4">
              <div className="serv_h3r">
                <div className="grid clearfix">
                  <figure className="effect-jazz mb-0">
                    <Link to="/contact">
                      <img
                        src="./assets/img/2007.png"
                        className="w-100"
                        alt="Help"
                      />
                    </Link>
                  </figure>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default DataAnalytics;
